"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EN: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    AR: [
        'يناير',
        'فبراير',
        'مارس',
        'إبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمير',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
    ],
};
